import { defineComponent as _defineComponent } from 'vue'
import { getProviderIconSrc } from '@/utils/provider-icons';
import type {
  TransformationAssetDto,
} from '@/api';

interface ConnectorSourceDestinationProps {
  sourcePlatform: TransformationAssetDto.sourcePlatform | undefined,
  sourcePlatformLabel: string | undefined,
  destinationPlatform: TransformationAssetDto.destinationPlatform | undefined,
  destinationPlatformLabel: string | undefined,

}

export default /*#__PURE__*/_defineComponent({
  __name: 'Connector-Source-Destination',
  props: {
  sourcePlatform: null,
  sourcePlatformLabel: null,
  destinationPlatform: null,
  destinationPlatformLabel: null
},
  setup(__props) {




return { __sfc: true,getProviderIconSrc }
}

})